import * as React from "react";
import { connect } from "react-redux";
import {
  Container,
  Dropdown,
  Accordion,
  Form,
  Button,
  Tab,
  Modal,
  Spinner,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { Utils } from "../Common/Utilis";
import { UserService } from "../Common/Services/UserService";
import { format, subDays, addDays, getDay, parseISO, isBefore } from "date-fns";
import { ConfirmationModal } from "../Common/Components/ConfirmationModal";
import { resolve, reject } from "q";
import { FaPencilAlt } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { VendorService } from "../Common/Services/VendorService";
import VendorMasterSlideout from "../Modules/Masters/VendorMasterSlideout";
import paginationFactory from "react-bootstrap-table2-paginator";
import { SingleDropdownListWithoutSearch } from "../Common/Components/SingleDropdownListWithoutSearch";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import ImportPayrollModal from "./ImportPayrollModal";
const { SearchBar } = Search;
import _ from "lodash";

import createDOMPurify from "dompurify";

import moment from "moment";
import { TransactionService } from "../Common/Services/TransactionService";

class ImportPayroll extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      htmlItem: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],
      orderid: 0,
      selectedcolumn: "All",
      selectOptions: [
        { id: "All", name: "All" },
        { id: "Vendor Code", name: "Vendor Code" },
        { id: "Vendor Name", name: "Vendor Name" },
        { id: "Address", name: "Address" },
        { id: "Phone Number", name: "Phone Number" },
        { id: "Status", name: "Status" },
      ],
      formData: {},
      selectedGroupId: 0,
    };
  }
  componentDidMount() {
    this.getImports();
    this.GetPayrollDetails({});
  }

  componentDidUpdate(prevProps) {
    if (prevProps.locationId != this.props.locationId) {
      this.getImports();
    }
  }

  closeModal = () => {
    this.setState({ showPopup: false, selectedRowId: 0 });
    this.getImports();
  };

  showPopup = () => {
    this.setState({
      showPopup: true,
    });
  };

  GetPayrollDetails = (requestlist: any) => {
    UserService.GetPayrollDetails(requestlist)
      .then(async (result: any | null) => {
        if (result != null) {
          this.setState(
            { payrollDetails: result, biWeekly: result.payperiod == 2 });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  getPayrollDateRange = () => {
    const { formData, payrollDetails } = this.state;
    if (!formData.payrollDate || !payrollDetails || payrollDetails.length === 0)
      return null;
    const payrollDate = new Date(formData.payrollDate);

    const payDetails = payrollDetails;
    const payperiod = payDetails.payperiod;
    const payweekdate = payDetails.payweekdate;

    const jsDayIndex = payweekdate % 7;
    const selectedDay = payrollDate.getDay();
    let diff = selectedDay - jsDayIndex;
    if (diff < 0) diff += 7;

    const periodStartDate = subDays(payrollDate, diff);
    console.log("selectedDay", selectedDay);
    console.log("jsDayIndex", jsDayIndex);

    const intervalDays = payperiod === 2 ? 13 : 6;
    const periodEndDate = addDays(periodStartDate, intervalDays);

    const startDateIso = new Date(periodStartDate).toISOString();
    const endDateIso = new Date(periodEndDate).toISOString();
    const endDateFormatted = format(periodEndDate, "MM/dd/yyyy");

    console.log("periodStartDate", startDateIso, endDateIso, endDateFormatted);

    this.setState({
      periodStartDate: startDateIso,
      periodEndDate: endDateFormatted,
    });
  };

  getImports = () => {
    TransactionService.getImports({})
      .then(async (result: any[] | null) => {
        if (result != null) {
          this.setState({
            searcResult: result,
            formData: {},
            selectedGroupId: 0,
            selectedRowId: 0,
            showGroups: false,
          });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

   syncPayroll = () => {
    this.setState({isSpinner:true});
    TransactionService.syncPayroll({})
      .then(async (result: any | null) => {
        if (result == true) {
        this.getImports();
        toast.success("Synced successfully.");
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      })
      .finally(() => {
      this.setState({isSpinner:false});
       });
  };

  rowStyle = (row, rowIndex) => {
    if (row.selected) {
      return {
        backgroundColor: "#c8e6c9",
        fontWeight: "bold",
        borderLeft: "4px solid #388e3c",
      };
    }
    return {};
  };

  handleSelectedItem1 = (control: any, id: any) => {
    let searcResult1 = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searcResult))
    );
    let chkisstatus = id == "Status" ? true : false;
    let chkisPhoneNumber = id == "Phone Number" ? true : false;
    let chkisaddress = id == "Address" ? true : false;
    let chkiscustomername = id == "Vendor Name" ? true : false;
    let chkiscustomercode = id == "Vendor Code" ? true : false;

    if (id == "All") {
      chkisstatus = true;
      chkisPhoneNumber = true;
      chkisaddress = true;
      chkiscustomername = true;
      chkiscustomercode = true;
    }

    this.setState(
      {
        searcResult: [],
        selectedcolumn: id,
        isstatus: chkisstatus,
        isphone_number: chkisPhoneNumber,
        isaddress: chkisaddress,
        iscompanyname: chkiscustomername,
        isvendorcode: chkiscustomercode,
      },
      () => {
        this.setState({ searcResult: searcResult1 });
      }
    );
  };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.setState({
        showSlideout: true,
        vendorid: row.vendor_id,
        isSpinner: false,
      });
    },
  };

  rowEvents1 = {
    onClick: (e: any, row: any, rowIndex: any) => {
      const formData = row;

      this.setState(
        {
          selectedGroupId: row.id,
          formData,
          isSpinner: false,
          showGroups: true,
        },
        () => {
          // this.getPayrollDateRange();
        }
      );
    },
  };

  showNewSlideOut = () => {
    this.setState({ showSlideout: true, vendorid: 0, isSpinner: false });
  };

  handleChange = (event: any, FieldType: string, index: any) => {
    let isStateChanged = true;
    let start = 0;
    let end = 0;

    let formData = { ...this.state.formData };

    if (FieldType === "description") {
      event.preventDefault();
      formData.groupdesc = event.target.value;
      this.setState({ formData, isStateChanged }, () => {});
    } else if (FieldType === "name") {
      event.preventDefault();
      formData.groupname = event.target.value;
      this.setState({ formData, isStateChanged }, () => {});
    }

    this.setState({ formData, isStateChanged, isSpinner: false }, () => {});
  };

  handleOnSelect = (row: any, isSelect: boolean) => {
    const vendorId = row.vendor_id;

    this.setState((prevState: any) => {
      let updatedVendorIds = [...prevState.selectedVendorIds];

      if (isSelect) {
        if (!updatedVendorIds.includes(vendorId)) {
          updatedVendorIds.push(vendorId);
        }
      } else {
        updatedVendorIds = updatedVendorIds.filter(
          (id: number) => id !== vendorId
        );
      }

      return { selectedVendorIds: updatedVendorIds };
    });
  };

  moreOptions = (eventKey: any) => {
    if (eventKey == "file") {
      this.showPopup();
    } else if (eventKey == "sync") {
      this.syncPayroll();
    } 
  };

  render() {
    const { formData } = this.state;

    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );
    const options = {
      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "25",
          value: 25,
        },
        {
          text: "50",
          value: 50,
        },

        {
          text: "All",
          value: this.state.searcResult.length,
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
    };
    const { showSlideout } = this.state;

    const columns = [
      {
        searchable: this.state.isvendorcode,
        dataField: "vendorcode",
        text: "Vendor Code",
        sort: true,
      },

      {
        searchable: this.state.iscompanyname,
        dataField: "company_name",
        text: "Vendor Name",
        sort: true,
      },
      {
        searchable: this.state.isaddress,
        dataField: "address",
        text: "Vendor Address",
      },

      {
        searchable: this.state.isphone_number,
        dataField: "contactPerson",
        text: "Contact Person",
      },

      {
        searchable: this.state.isphone_number,
        dataField: "phone_number",
        text: "Contact Phone",
      },

      {
        dataField: "status",
        text: "Status",
        sort: true,
        headerStyle: { width: "200px" },
        headerClasses: "text-center",
        classes: "text-center",

        searchable: this.state.isstatus,
        //searchable:this.state.isdueDate,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <EllipsisWithTooltip placement="bottom">
                <span
                  className={
                    row.status === "Active"
                      ? "badge badge-pill badge-primary color-green"
                      : "badge badge-pill badge-primary color-red"
                  }
                >
                  {" "}
                  {row.status}{" "}
                </span>
              </EllipsisWithTooltip>
            </>
          );
        },
      },
    ];

    const grpcolumns = [
      {
        searchable: true,

        dataField: "payrollDate",
        text: "Payroll Date",
        sort: true,
        headerClasses: "text-start",
        classes: "text-start",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
            <div className="d-flex justify-content-between align-items-center w-100">
              <span>{moment(row.payrollDate).format("MM/DD/YYYY")}</span>

              <span className="badge badge-pill badge-primary color-orange ms-2">
                {row.type}
              </span>
            </div>
          </EllipsisWithTooltip>
          );
        },
      },
    ];

    const grpcolumns1 = [
      // {
      //   // headerStyle: { width: "500px" },
      //   dataField: "accPer",
      //   text: "Act. Per.",
      //   headerClasses: "text-start",
      //   classes: "text-start",
      // },
      {
        dataField: "serialNumber",
        text: "Sr No.",
        headerClasses: "text-start",
        classes: "text-start",
        formatter: (cell: any, row: any, rowIndex: number) => rowIndex + 1,
      },
      {
        // headerStyle: { width: "500px" },
        dataField: "vendor",
        text: "Vendor",
        headerClasses: "text-start",
        classes: "text-start",
      },
      {
        // headerStyle: { width: "500px" },
        dataField: "coaCode",
        text: "COA",
        headerClasses: "text-start",
        classes: "text-start",
      },
      {
        // headerStyle: { width: "500px" },
        dataField: "coa",
        text: "COA Name",
        headerClasses: "text-start",
        classes: "text-start",
      },
       {
        // headerStyle: { width: "500px" },
        dataField: "description",
        text: "Description / CheckNo",
        headerClasses: "text-start",
        classes: "text-start",
      },
      {
        dataField: "debit",
        text: "Debit",
        headerClasses: 'text-center',
        classes: "text-center pe-4 divred",
        // sort: true,
        searchable: false,
        // headerStyle: { width: '100px' },
        formatter: (cell: any, row: any, rowIndex: any) => {
           const value = row.debit && row.debit > 0 ? row.debit : row.credit;
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.currencyFormat(value)}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "credit",
        text: "Credit",
        headerClasses: 'text-center',
        classes: "text-center pe-4 divgreen",
        // sort: true,
        searchable: false,
        // headerStyle: { width: '100px' },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.currencyFormat(0)}
            </EllipsisWithTooltip>
          );
        },
      },
    ];
    return (
      <>
        <React.Fragment>
          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex  ">
              Payroll Import
              <div className="action-group d-flex flex-row ml-auto">
                <Button onClick={() => window.open("http://payroll.cimmple.net/", "_blank")}>Go to CimmplePay</Button>
                {/* <Button onClick={this.showPopup}>New Import</Button> */}
                <Dropdown
                                    className="more-action"
                                    onSelect={(event) => { this.moreOptions(event); }}
                                  >
                
                   <Dropdown.Toggle className="addNewVendor">
                     Import
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                    <Dropdown.Item eventKey="file">New File</Dropdown.Item>
                    <Dropdown.Item eventKey="sync">Payroll Sync</Dropdown.Item>
                    </Dropdown.Menu>
                    </Dropdown>
              </div>
            </div>

            <div className="row">
              <section className="mt-3 col-3">
                <ToolkitProvider
                  keyField="id"
                  data={this.state.searcResult.filter(
                    (row) => row.rowType == 1
                  )}
                  columns={grpcolumns}
                  className="table table-striped table-borderless align-middle"
                  search
                >
                  {(props) => (
                    <div>
                      <section className="d-flex flex-wrap gap-3 pb-2">
                        <div className="position-relative">
                          <SearchBar {...props.searchProps} />
                        </div>
                      </section>
                      <section className="pb-3">
                        <div className="table-responsive divbottom">
                          <div className="ml-auto transactions-list">
                            <BootstrapTable
                              {...props.baseProps}
                              rowEvents={this.rowEvents1}
                              keyField="id"
                              selectRow={{
                                mode: "radio",
                                selected: this.state.selectedRowId
                                  ? [this.state.selectedRowId]
                                  : [],
                                onSelect: (row) => {
                                  this.setState({ selectedRowId: row.id });
                                },
                                clickToSelect: true,
                                hideSelectColumn: true,
                                style: {
                                  backgroundColor: "#c8e6c9",
                                  fontWeight: "bold",
                                  borderLeft: "4px solid #388e3c",
                                },
                              }}

                              // pagination={paginationFactory(options)}
                            />
                          </div>
                        </div>
                      </section>
                    </div>
                  )}
                </ToolkitProvider>
              </section>
              {this.state.showGroups ? (
                <section className="mt-3 col-9">
                  <section className="col-12 mb-4">
                    <h4 className="fw-bold mb-3">
                      Payroll Log for{" "}
                      {moment(formData.payrollDate).format("MM/DD/YYYY")}
                    </h4>
                    <hr className="mt-0 mb-3" />

                    <div className="row mb-2">
                      <div className="col-6">
                        <span className="fw-semibold px-2">Imported by:</span>
                        <span>
                          {/* {formData.userName} */}
                          Automatic
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="fw-semibold px-2">Type (Check or COA):</span>
                        <span>
                          {formData.type}
                        </span>
                      </div>
                      
                    </div>

                    <div className="row mb-2">
                      <div className="col-6">
                        <span className="fw-semibold px-2">
                          Date of Import:{" "}
                        </span>
                        <span>
                          {moment(formData.createdDate).format("MM/DD/YYYY")}
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="fw-semibold px-2">
                          Accounting Period:{" "}
                        </span>
                        <span>{formData.accPer}</span>
                      </div>
                     
                    </div>
                    
                     <div className="row"> 
                      <div className="col-6">
                        <span className="fw-semibold px-2">
                          Pay Period End Date:{" "}
                        </span>
                        {/* <span>{this.state.periodEndDate || ""}</span> */}
                        <span>{formData.endDate || ""}</span>
                      </div></div>
                  </section>

                  <ToolkitProvider
                    keyField="vendor_id"
                    data={this.state.searcResult.filter(
                      (row) =>
                        row.rowType == 2 &&
                        row.importid == this.state.selectedGroupId
                    )}
                    columns={grpcolumns1}
                    search
                  >
                    {(props) => (
                      <div>
                        {/* <section className="d-flex flex-wrap gap-3 pb-2">
                          <div className="position-relative">
                            <SearchBar {...props.searchProps} />
                          </div>
                        </section> */}
                        <section className="">
                          <div className="table-responsive divbottom">
                            <div
                              className="ml-auto transactions-list scroll p-0"
                              style={{ maxHeight: "450px" }}
                            >
                              <BootstrapTable
                                {...props.baseProps}
                                keyField="id"
                              />
                            </div>
                          </div>
                        </section>
                      </div>
                    )}
                  </ToolkitProvider>
                </section>
              ) : (
                <section className="mt-3 col-8 mx-auto text-center">
                  <span>** Select the payroll date to view logs **</span>
                </section>
              )}
            </div>

            {this.state.isSpinner && (
              <div className="loader-spinner d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="success" />
              </div>
            )}

            {this.state.showPopup && (
              <ImportPayrollModal
                showModal={this.state.showPopup}
                onClose={this.closeModal}
              />
            )}
          </Container>
        </React.Fragment>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId,
});

export default connect(mapStateToProps)(ImportPayroll);
